import Image from 'next/image';
import PropTypes from 'prop-types';
import React from 'react';
import { Dropdown, FloatingLabel, Form, InputGroup } from 'react-bootstrap';
import { IC_DEFAULT } from '../../../Assets/images';
import MobileInputFieldStyled from './MobileInputFieldStyled';
import { countryCodeData } from '@common/Utility/country-utils';

const MobileInputFieldControl = (props) => {
  const fetchImageFromExtension = (countryCode) => {
    let newImage = '';
    countryCodeData.forEach((element) => {
      if (element.value === countryCode) {
        newImage = element.imageSrc;
      }
    });
    return newImage;
  };

  const image = fetchImageFromExtension(props?.extValue);

  const renderLabel = () => <Form.Label className={props.readOnly && 'readOnly'}>{props?.label}</Form.Label>;

  return (
    <MobileInputFieldStyled>
      <Form.Group>
        <InputGroup className={props?.isInvalid && 'is-invalid'}>
          <Dropdown className="country_dropdown" onSelect={props.handleSelect}>
            <Dropdown.Toggle className="country_dropdown">
              <span className="flag_icon">
                <Image src={image !== '' ? image : IC_DEFAULT} alt="Picture of the author" width={24} height={16} />
              </span>
              <span>{props?.extValue}</span>
            </Dropdown.Toggle>

            <Dropdown.Menu className="list_country_dropdown">
              {countryCodeData &&
                countryCodeData.map((element, i) => (
                  <Dropdown.Item key={i} eventKey={element?.value}>
                    <span className="flag_icon">
                      <Image
                        src={element?.imageSrc ? element?.imageSrc : IC_DEFAULT}
                        alt="Picture of the author"
                        width={24}
                        height={16}
                      />
                    </span>
                    <span>{element?.value}</span>
                  </Dropdown.Item>
                ))}
            </Dropdown.Menu>
          </Dropdown>
          <FloatingLabel controlId={props?.name} label={renderLabel()}>
            <Form.Control
              type={props?.textType}
              name={props?.name}
              placeholder={props?.placeholder}
              className="inputField"
              value={props?.valueType}
              extValue={props?.extValue}
              onChange={props.onChange}
              isInvalid={props?.isInvalid}
            />
            <Form.Control.Feedback type="invalid">{props?.errorMessage}</Form.Control.Feedback>
          </FloatingLabel>
        </InputGroup>
      </Form.Group>
      {props.children}
    </MobileInputFieldStyled>
  );
};

MobileInputFieldControl.propTypes = {
  children: PropTypes.any,
  label: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  textType: PropTypes.any,
  extValue: PropTypes.string,
  valueType: PropTypes.string,
  handleSelect: PropTypes.any,
  readOnly: PropTypes.any,
  onChange: PropTypes.any,
  isInvalid: PropTypes.any,
  errorMessage: PropTypes.any,
  selectDisabled: PropTypes.bool,
};

MobileInputFieldControl.defaultProps = {
  title: '',
  selectDisabled: false,
};

export default MobileInputFieldControl;
